module.exports = __webpack_public_path__ + "static/media/rin-full.e0ab4547.png";